export async function waitForTenantSlug(timeout = 5000, interval = 200) {
  const start = Date.now()

  return new Promise((resolve, reject) => {
    const check = () => {
      const tenantId = sessionStorage.getItem("tenant")
      if (tenantId) return resolve(tenantId)

      if (Date.now() - start >= timeout) {
        return reject(
          new Error("Tenant ID not found in sessionStorage within timeout")
        )
      }

      setTimeout(check, interval)
    }
    check()
  })
}
